import "@aws-amplify/ui-react/styles.css";
import {
  withAuthenticator,
  Button,
  Heading,
  Image,
  View,
  Text,
  TextField,
  Card,
  Flex,
} from "@aws-amplify/ui-react";
import { APaddedCenter } from "../components/layout";
import { AH2, AH4 } from "../components/text";
import { useContext } from "react";
import { GlobalContext } from "../context/global";
import { useNavigate } from "react-router-dom";
import Logo from "../media/aere_logo_caption_black.png";
import styled from "styled-components";


const LogoImage = styled(Image)`
  max-width:100%;
  width:300px;
  margin-top:40px;
  margin-bottom:40px;
`


export const ViewCheckoutComplete = () => {
    const navigate = useNavigate();
    
    //TODO - API post up that we completed checkout?
    const next = () => {
      navigate("/")
    }

    return <APaddedCenter>
        <LogoImage src={Logo} alt="aere nutrition logo" />
        <AH2>Thanks for your order!</AH2><br/>
        <AH4>We'll be in touch when your order ships.</AH4>
        <br/>
      <Flex direction="Column" justifyContent="center">
         <Button variation="primary" onClick={() => { next() }}>Create another event</Button>
      </Flex>
    </APaddedCenter>
}